import React from 'react'
import Axios from 'axios'
import { API_HOST,axiosRequest } from './../../constants/server.constant';
import ReCAPTCHA from "react-google-recaptcha";
import  ReactTooltip  from 'react-tooltip';
import { SessionService } from './../../services/session.service';
import { Redirect } from 'react-router';



class Partnerlogin extends React.Component{
    constructor(props){
        super(props)
        this.state = {
           hidePwd : true,
           isPwdShown : false,
           isChecked : false,
           username : "",
           password : "",
           forgotEmail : "",
           isUsernameEmpty : false,
           isPasswordEmpty : false,
           loading: true,
           wrongcreds:false,
           loggedIn : false,
           showLoader : false,
           isLoginBox : true,
           isForgotPassword:false,
           isForgotEmailEmpty : false,
           showLoader:true,
           isAction:false
        }
        this.userNameFocus = React.createRef()
        this.passwordFocus = React.createRef()
        this.forgotEmailFocus = React.createRef()
        this.handleToggle= this.handleToggle.bind(this)
        this.handleInputs = this.handleInputs.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.submitForgotForm = this.submitForgotForm.bind(this)
        this.loadcss = this.loadcss.bind(this)
        this.recaptchaRef = React.createRef()
        this.nameInput = React.createRef()
        this.inputFocus = this.inputFocus.bind(this)
        
        
    }
    inputFocus = (event,param)=>{
        if(param === "pass"){
            if(this.state.username.length <=0){
                this.setState({
                    isUsernameEmpty : true
                })
            }
            if(this.state.username.length >0){
                this.setState({
                    isUsernameEmpty : false
                })
            }
        }
        if(param === "forgotblur"){
            if(this.state.forgotEmail.length <=0){
                this.setState({
                    isForgotEmailEmpty : true
                })
            }
            if(this.state.username.length >0){
                this.setState({
                    isForgotEmailEmpty : false
                })
            }
        }
        
        
    }
    componentDidMount() {
       // asyncCall().then(() => this.setState({ loading: true }));
        this.loadcss()
        
        document.title = "IDrive® Compute | Sign In"
        document.styleSheets[1].disabled = true
       
    }
    componentWillUnmount(){
        document.styleSheets[1].disabled = false
        var disbale1 = "partner-login.css"
        var disbale2 = "partner-responsive.css"
        Object.values(document.styleSheets).forEach(sheet => {
            let sheetLink = sheet.href
            if(sheetLink !== null){
                let urlLastName =  sheetLink.split("/").pop()
                let sheetName = urlLastName.split("?")

                if (disbale1.indexOf(sheetName[0]) > -1) sheet.disabled = true;
                if (disbale2.indexOf(sheetName[0]) > -1) sheet.disabled = true;
            }
           
          });

        
    }
    loadcss = ()=>{
        document.title = "IDrive® Compute | Sign In"
        const link = document.createElement("link")
        link.href = "https://www.idrivecompute.com/partner/include/css/partner-login.css?v=1.0"
        link.rel = "stylesheet"
        link.type = "text/css"
         document.head.appendChild(link)

        const link1 = document.createElement("link")
        link1.href = "https://www.idrivecompute.com/partner/include/css/partner-responsive.css?v=1.0"
        link1.rel = "stylesheet"
        link1.type = "text/css"
        document.head.appendChild(link1)
        setTimeout(()=>{
            this.setState({
                showLoader:false
            })
        },500)
    }

    handleToggle(event){
       
        if(event.target.type === "checkbox"){
            this.setState({
                isChecked : !this.state.isChecked
            })
        }
        else{
            this.setState({
                hidePwd:!this.state.hidePwd,
                isPwdShown : !this.state.isPwdShown,
                
            }) 
        }
    }

    handleInputs(event){
        this.setState({
            wrongcreds : false,
            isCancelledUser:false,
            accountCancel:false,
            isNonPaymentUser : false,
            isForgotEmailEmpty : false
        })

        let name = event.target.name
        let val = event.target.value

        this.setState ({
            [name] : val
        })
        if(name === "username"){
            if(val.length > 0){
                this.setState({
                    isUsernameEmpty : false
                })
            }
            else if(val.length <= 0){
                this.setState({
                    isUsernameEmpty : true
                })
            }
        }
        if(name === "password"){
            if(val.length > 0){
                this.setState({
                    isPasswordEmpty : false
                })
            }
            else if(val.length <= 0){
                this.setState({
                    isPasswordEmpty : true
                })
            }
        }
    }

    onRecaptchaChange = (event) => {
        if(this.state.isLoginBox){
            this.doAuthentication(event);
        }
        if(this.state.isForgotPassword){
            this.callForgot(event)
        }
       
    }

    callForgot(event){
        this.setState({
            isAction:true
        })
        Axios.get(API_HOST+"/bounty-partner/resetpassword?name="+this.state.forgotEmail,axiosRequest).then(resp=>{
            
            this.setState({
                forgotPasswordCreds : true,
                isAction:false
            }) 
         
        }).catch(error=>{
            this.setState({
                forgotPasswordCreds : true,
                isAction:false
            })
        })
    }


    doAuthentication(event) {
        console.log(event)
        this.setState({
            isAction:true
        })
        const history = this.props.history
        let result = "";
        const data = {
            username:this.state.username.trim(),
            password:this.state.password
        }
        //var captcha_response = $("#g-recaptcha-response").val();
        //console.log(captcha_response)
        
        Axios.post(API_HOST+'/bounty-partner/login?captcha='+event,
            JSON.stringify({
               password: data.password,
               username: data.username
            })
            ,axiosRequest).then( 
                (response) => { 
                    console.log(response)
                    if(response.data.hasOwnProperty('token')){
                        SessionService.setCookie("partner_username",data.username)
                        window.location.href =API_HOST+'/bounty-partner/authnticate/'+response.data.token
                    }
                    else{
                        if(this.recaptchaRef.current){
                            this.recaptchaRef.current.reset()
                        }
                        this.setState({
                            wrongcreds : true,
                            errmsg : "Invalid Email or Password",
                            isAction:false
                        })
                    }
                   
                }, 
                (error) => { 
                    if(this.recaptchaRef.current){
                        this.recaptchaRef.current.reset()
                    }
                    this.setState({
                        wrongcreds : true,
                        errmsg : "Error while connecting to server, try again!",
                        isAction:false
                    })
                } 
            );
    }

    submitForm(event){
        event.preventDefault()
         
        if(!(this.state.password.length>0)){
            this.setState({
                isPasswordEmpty : true
            })
            this.passwordFocus.current.focus()
            
        }
        if(!(this.state.username.length > 0)){
            this.setState({
                isUsernameEmpty : true
            })
            this.userNameFocus.current.focus()
            
        }
        if(this.state.password.length>0 && this.state.username.length > 0) { 
            this.recaptchaRef.current.execute()
        }
    }

    submitForgotForm(event){
        event.preventDefault()
        if(this.state.forgotEmail.trim().length <=0){
            this.setState({
                isForgotEmailEmpty:true
            })
            this.forgotEmailFocus.current.focus()
        } 
        else{
            this.recaptchaRef.current.execute()
        }
    }

    getForgotBox=(param)=>{
        if(param){
            this.setState({
                isLoginBox : false,
                isForgotPassword:true,
                username : "",
                password : "",
                forgotEmail : "",
                isUsernameEmpty : false,
                isPasswordEmpty : false,
                isForgotEmailEmpty:false,
                wrongcreds:false,
                forgotPasswordCreds:false

            })
            setTimeout(()=>{
                this.forgotEmailFocus.current.focus()
            },100)
        }
        else{
            this.setState({
                isLoginBox : true,
                isForgotPassword:false,
                username : "",
                password : "",
                forgotEmail : "",
                isUsernameEmpty : false,
                isPasswordEmpty : false,
                isForgotEmailEmpty:false,
                wrongcreds:false,
                forgotPasswordCreds:false
            })
            setTimeout(()=>{
                this.userNameFocus.current.focus()
            },100)
           
        }
       
    }

    render(){
        if(this.state.showLoader){
            return(
                <div class="full_page_loader" style={{display: this.state.showLoader?"block" :"none"}}><div class="loader_icon"></div></div>
            )
        }
        if(SessionService.getCookie("_partner_cookie")){
            return <Redirect to = "/bounty-partner/index" />
        }
        return(
            <div className="wraper">
                <div class="full_page_loader" style={{display: this.state.showLoader?"block" :"none"}}><div class="loader_icon"></div></div>
                <div class="full_page_loader" style={{display: this.state.isAction?"block" :"none"}}><div class="loader_icon"></div></div>
                <div className="wrap_con">
                    <div className="body_con">
                        <div className="loginbox">
                        <div className="logo-section"> <a className="singup-logo" href="https://www.idrivecompute.com/">Logo</a> </div>
                        <div className="login_innerbox" style = {{display:this.state.isLoginBox?"":"none"}}>
                            <div className="box_title"> Login to your account </div>
                            <form onSubmit = {this.submitForm}> 
                                <div class="msg_box" style={{display: this.state.wrongcreds? "block":"none"}}>
                                <div class="common_msg error">
                                    <div class="icon"></div><div class="info">Invalid Email or Password</div>
                                </div>
                                </div> 
                                        
                                <div className="intBox">
                                    <label>Username</label>
                                    <input ref={this.userNameFocus} value = {this.state.username} autoFocus  id = "nameinput" type="text" name="username" className="inputTxt" autoComplete = 'off'  onChange = {this.handleInputs} ></input>
                                    <i className="email_ico"></i>
                                    {this.state.isUsernameEmpty ?<span className="error_msg" style = {{display : 'block'}}>Username cannot be blank</span> :""}
                                </div>
                                <div className="intBox">
                                <label>Password</label>
                                <div className="pwd_field_wrap">
                                    <input type={this.state.hidePwd ? "password" : "text"} maxLength = "20" value = {this.state.password} ref = {this.passwordFocus} name="password" className="inputTxt" onChange = {this.handleInputs} onClick = {(e)=>this.inputFocus(e,"pass")} onFocus = {(e)=>this.inputFocus(e,"pass")}></input>
                                    <i className="pswd_ico"></i>
                                    <span data-tip data-for = "password" className={this.state.isPwdShown?"pwd_field_eyeIcon show_pwd":"pwd_field_eyeIcon"} onClick = {this.handleToggle}></span>
                                </div><ReactTooltip  id="password" place="right" effect="solid">
                                                {this.state.isPwdShown?"Hide":"Show"} 
                                            </ReactTooltip>
                                {this.state.isPasswordEmpty ? <span className="error_msg" style = {{display : "block"}} >Password cannot be blank</span>:""}
                                </div>
                                <div>
                                    <div className="forGtPass" id="forgotPass" tabIndex="4" onClick = {()=>{this.getForgotBox(true)}}>Forgot Password?</div>
                                </div>
                                <div className="partner_btnBlk">
                                <input type="submit" name="" value="Sign in" className="loginBtn"  data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible" onFocus = {(e)=>this.inputFocus(e,"submit")}></input>      
                                </div>
                                
                            </form>
                            </div>
                            <div className="forgotbox" style={{display:this.state.isForgotPassword?"":"none"}}>
                                <div className="forgot_innerbox">
                                    <div className="box_title">Forgot Password?</div>
                                    <form onSubmit = {(e)=>this.submitForgotForm(e)}>
                                    <div class="msg_box" style={{display: this.state.forgotPasswordCreds? "block":"none"}}>
                                    <div class="common_msg success">
                                        <div class="icon"></div><div class="info">If your email/username exists in our system, you will receive an email with instructions to reset the password.</div>
                                    </div>
                                    </div> 
                                    <div class="intBox">
                                        <p class="frget_alert">A link to set a new password for your account will be sent to the email address.</p>
                                        <span class="frget_info">You may need to check your spam folder or add <strong>support@idrive.com</strong> and <strong>support@send.idrive.com</strong> to your contact list to make sure that emails get delivered to your inbox.</span>
                                    </div>
                                    <div className="intBox">
                                        <label for="frget_email">Enter Your Valid Username</label>
                                        <input type="text" ref = {this.forgotEmailFocus} value = {this.state.forgotEmail} name = "forgotEmail" className="inputTxt" tabIndex="5" onChange = {this.handleInputs} onBlur = {(e)=>this.inputFocus(e,"forgotblur")}/>
                                        {this.state.isForgotEmailEmpty ?<span className="error_msg" style = {{display : 'block'}}>Username cannot be blank</span> :""}
                                    </div>
                                    <div className="intBox" style = {{display:"none"}}>
                                        <div className="lablTxt">Verification Code</div>
                                        <span id="verification"><img src="https://www.idrivecompute.com/partner/include/images/776113556.png" className="ver_img"/></span>
                                        <span>
                                        <input type="text" placeholder="Verification" className="verTxt" maxLength="4" tabIndex="6"/>
                                        </span>
                                    </div>
                                    <div className="partner_btnBlk">
                                    <input type="submit" value="Send" className="loginBtn" tabIndex="7" data-sitekey="6LfvAiwUAAAAANov16A_dcQhR952_39cma0Itaof" data-callback="onSubmit" data-size="invisible"  />
                                    </div>
                                    
                                    <div className="signin_lnk"><a href="javascript:;" class="backtoLogin" onClick = {()=>{this.getForgotBox(false)}}>Back to Login</a> </div>
                                    </form>
                                </div>
                            </div>
                            <footer>
                                <p className="ftr_txt">&copy; IDrive Inc</p>
                            </footer>
                            <div className="captcha">
                                <ReCAPTCHA
                                    sitekey="6LfMaG8aAAAAADtCmgI91y-9wbCjnaDTQwwIUv6-"
                                    onChange={(e) => this.onRecaptchaChange(e)}
                                    ref={this.recaptchaRef}
                                    size="invisible"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}

export default Partnerlogin
